import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import * as actions from '../../actions'
import { FORM_PENDIENTE_AUTORIZ } from '../../../../config/forms'
import GrillaCeaPendienteAutoriz from '../../components/GrillaCeaPendienteAutoriz'
import { Button } from 'react-bootstrap'
import { confirmAlert } from 'react-confirm-alert'
import moment from 'moment'
import { INTERVALO_CORTO } from '../../../../config/settings'
import { toast, ToastContainer } from 'react-toastify'
import 'react-confirm-alert/src/react-confirm-alert.css'

function PendienteAutoriz (props) {
  const { getPendienteAutoriz, transacciones, pendientesProcesados, errorProcesados, ceaPendienteAutoriz } = props
  const entregadores = props.roles.filter(roles => roles === 'CONSULTA_VENDEDOR')
  const rolEntregador = entregadores.length > 0

  const generarData = () => {
    const parsedData = []
    ceaPendienteAutoriz && ceaPendienteAutoriz.map((camion) => {
      if (!rolEntregador || (rolEntregador && camion.cereal !== 'Cebada Cervecera')) {
        const fecha = moment(camion.fechaDeCalado).format('DD-MM-YYYY HH:mm')
        const variedad = ((camion.cerealVariedad).trim() === 'UNDEF') ? ' - ' : camion.cerealVariedad
        const puesto = camion.puestoDeCalado.replace('_', ' ')
        const peritoCompleto = camion.peritoCalador && camion.peritoCalador.startsWith('{')
          ? camion.peritoCalador.split('"') : camion.peritoCalador
        const perito = peritoCompleto && peritoCompleto !== camion.peritoCalador ? peritoCompleto[5].split(':') : camion.peritoCalador
        parsedData.push({ ...camion, fechaCalado: fecha, variedad: variedad, puesto: puesto.toUpperCase(), perito: perito })
      }
      return parsedData
    })
    return parsedData
  }

  const data = generarData()

  useEffect(() => {
    getPendienteAutoriz()
  }, [getPendienteAutoriz])

  useEffect(() => {
    let mensaje
    if (pendientesProcesados > 0 && !errorProcesados) {
      mensaje = pendientesProcesados === 1
        ? 'La carga pendiente fue procesada correctamente'
        : `Se procesaron correctamente ${pendientesProcesados} cargas pendientes. `
      toast.success(mensaje)
      if (transacciones && transacciones.length > 0) {
        const extraMessage = `Transacciones en ARCA : ${transacciones.toString()}`
        toast.info(extraMessage)
      }
    } else if (errorProcesados) {
      mensaje = pendientesProcesados === 1
        ? 'No se pudo procesar correctamente la carga pendiente.'
        : `No se pudo procesar correctamente las ${pendientesProcesados} cargas pendientes. `
      toast.error(mensaje)
    }
  }, [pendientesProcesados, errorProcesados, transacciones])

  const onSelectionChange = (selections) => {
    props.cargarPendientes(selections)
  }

  const handleAutorizar = async () => {
    if (rolEntregador) {
      const dispositivoHuella = 'ENTREGAU'
      const entregador = await props.dialogHuella(dispositivoHuella)
      if (entregador && entregador !== undefined) {
        const finalizar = false
        await props.autorizarPendientes(finalizar, entregador)
      } else {
        toast.error('No se puede finalizar el proceso sino está autorizado por un entregador')
      }
    } else {
      props.autorizarPendientes()
    }
  }

  const handleRechazar = async () => {
    if (rolEntregador) {
      const dispositivoHuella = 'ENTREGAU'
      const entregador = await props.dialogHuella(dispositivoHuella)
      if (entregador && entregador !== undefined) {
        const finalizar = false
        await props.rechazarPendientes(finalizar, entregador)
      } else {
        toast.error('No se puede finalizar el proceso sino está autorizado por un entregador')
      }
    } else {
      props.rechazarPendientes()
    }
  }

  const renderAcciones = () => {
    const { pendientesSeleccionados } = props
    const disabled = pendientesSeleccionados.length === 0

    return (
      <div className='botones-acciones-aut-rech-calado'>
        <Button
          variant='danger'
          onClick={() => {
            confirmAlert({
              title: 'Atención',
              message: '¿Esta seguro que desea RECHAZAR las cartas de porte seleccionadas?',
              buttons: [
                {
                  label: 'Aceptar',
                  onClick: () => handleRechazar()
                },
                {
                  label: 'Cancelar',
                  onClick: () => null
                }
              ]
            })
          }}
          disabled={disabled}
          size='md'
        >
          Rechazar
        </Button>

        <Button
          variant='success'
          onClick={() => {
            confirmAlert({
              title: 'Atención',
              message: '¿Esta seguro que desea AUTORIZAR las cartas de porte seleccionadas?',
              buttons: [
                {
                  label: 'Aceptar',
                  onClick: () => handleAutorizar()
                },
                {
                  label: 'Cancelar',
                  onClick: () => null
                }
              ]
            })
          }}
          disabled={disabled}
          size='md'
        >
          Autorizar
        </Button>

        <h2 style={{ fontWeight: 'bold' }}>
          Total: {(data.length) ? data.length : 0}
        </h2>

      </div>
    )
  }

  return (
    <div className='calado-pendiente-autoriz'>
      <ToastContainer autoClose={INTERVALO_CORTO} />
      <h2 style={{ marginBottom: '3%' }}>Pendiente de autorización</h2>
      {props.requestingCeaPendienteAutoriz
        ? (<span>Consultando...</span>)

        : (<div>
          <GrillaCeaPendienteAutoriz
            rows={data}
            onSelectionChange={onSelectionChange}
          />
          {ceaPendienteAutoriz && <> {renderAcciones()}</> }
        </div>)
      }
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    requestingCeaPendienteAutoriz: state.calado.requestingCeaPendienteAutoriz,
    ceaPendienteAutoriz: state.calado.ceaPendienteAutoriz,
    pendientesSeleccionados: state.calado.pendientesSeleccionados,
    pendientesProcesados: state.calado.pendientesProcesados,
    errorProcesados: state.calado.errorPendientesProcesados,
    transacciones: state.calado.pendientesTransacciones,
    roles: state.auth.roles
  }
}

const withRedux = connect(mapStateToProps, actions)
export default withRedux(
  reduxForm({
    form: FORM_PENDIENTE_AUTORIZ
  })(PendienteAutoriz)
)
